import { configureStore } from '@reduxjs/toolkit';
import authSlice from '../slices/authSlice';
import filterSlice from 'src/slices/filterSlice';
import appDataSlice from 'src/slices/appDataSlice';
const store = configureStore({
  reducer: {
    auth: authSlice,
    filters: filterSlice,
    appData: appDataSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
